import { attach, createEvent, sample } from 'effector'
import { createAction } from 'effector-action'

import { getRegisterInfo } from '@portal/client-info'
import * as lib from '@portal/lib/yahoo-oauth-popup'

import { portalProfileAPI } from '@/entities/profile/portal'
import { env } from '@/shared/config'
import { $lang, attachI18n } from '@/shared/lib/i18n'
import { navigateTo } from '@/shared/lib/next'
import { toast } from '@/shared/lib/toast'
import { modal } from '@/shared/ui/modal'

export const yahooLoginButtonClicked = createEvent()

const getAccessTokenFx = attach({ effect: lib.getAccessTokenFx })

sample({
    clock: yahooLoginButtonClicked,
    source: $lang,
    fn: (lang) => ({
        lang,
        clientID: env.OAUTH_YAHOO_CLIENT_ID,
        redirectURI: lib.getRedirectURI(env.PUBLIC_URL),
    }),
    target: getAccessTokenFx,
})

const yahooLoginFx = attach({ effect: portalProfileAPI.yahooLogin })

createAction({
    clock: getAccessTokenFx.done,
    target: { yahooLoginFx },
    fn: (target, { params, result }) => {
        // popup closed or timed out
        if (!result) return

        target.yahooLoginFx({
            oauth_access_code: result.code,
            register_info: getRegisterInfo(params.lang),
        })
    },
})

sample({
    clock: yahooLoginFx.done,
    target: [modal.closeAll, navigateTo('/play', { replace: true })],
})

sample({
    clock: yahooLoginFx.fail,
    target: attachI18n(toast.errorFx, 'TEXT_TOAST_FAIL'),
})
